import { render, staticRenderFns } from "./jsgl.vue?vue&type=template&id=ae88fe02&scoped=true&"
import script from "./jsgl.vue?vue&type=script&lang=js&"
export * from "./jsgl.vue?vue&type=script&lang=js&"
import style0 from "./jsgl.vue?vue&type=style&index=0&id=ae88fe02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae88fe02",
  null
  
)

export default component.exports